import { GenericUploadFileStateType } from '@/types';
import { atom } from 'jotai';

export const pipeSpecUploadState = atom<GenericUploadFileStateType>( {
    state: 'idle',
    error: undefined,
    inputCsv: undefined,

    inputRef: null,
  });
